import { Typography } from "@mui/material";

interface Props {
  buyerName: string;
}

const EInvoiceDetails = ({ buyerName }: Props) => (
  <Typography variant="caption">
    <Typography variant="caption" color="textSecondary">
      Bill To on the e-invoice:
    </Typography>{" "}
    {buyerName}
  </Typography>
);

export default EInvoiceDetails;
